import { render } from "./contactInfo.vue?vue&type=template&id=6a4b6d03"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Event/Preview/contactInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a4b6d03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a4b6d03', __exports__)) {
    console.log('reload')
    api.reload('6a4b6d03', __exports__)
  }
  
  module.hot.accept("./contactInfo.vue?vue&type=template&id=6a4b6d03", () => {
    console.log('re-render')
    api.rerender('6a4b6d03', render)
  })

}


export default __exports__